module.exports = __webpack_public_path__ + "img/KAMCH.153ad868.png";